import React from "react";
import tw from "tailwind-styled-components";
import moment from "moment";
import Model from "../Model";
import { FaMale, FaFemale } from "react-icons/fa";

const ViewDetailStaff = ({ selectedData, setViewDetailStaff }) => {
  const staffs = selectedData?.staffs || [];

  return (
      <Model width ={`w-11/12 max-w-2xl`}onClick={(e) => e.stopPropagation()} setOpenModel={setViewDetailStaff}>
        <Header>
          <h2 className="text-lg font-semibold">
            {selectedData?.name}:
          </h2>
        </Header>

        {staffs.length === 0 ? (
          <p className="text-center py-6 text-gray-500">
            No staff found
          </p>
        ) : (
          staffs.map((staff) => (
            <StaffRow key={staff.id}>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full flex items-center justify-center bg-gray-100 text-xl">
                  {staff.gender === 1 ? (
                    <FaMale className="text-blue-600" />
                  ) : (
                    <FaFemale className="text-pink-600" />
                  )}
                </div>

                <div className="flex flex-col">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-zinc-900 text-sm">
                      {staff.name}
                    </span>
                    <span
                      className={`w-1 h-1 rounded-full ${
                        staff.status === 1
                          ? "bg-green-500"
                          : "bg-red-500"
                      }`}
                      title={
                        staff.status === 1 ? "Active" : "Inactive"
                      }
                    />
                  </div>

                  <span className="text-yellow-500 text-[10px]">
                    #{staff.mobile}
                  </span>
                </div>
              </div>

              <div className="text-xs text-gray-500 text-right">
                Last Login
                <div className="font-medium text-gray-700">
                  {staff.lastLogin
                    ? moment(staff.lastLogin).format(
                        "DD MMM YYYY, hh:mm A"
                      )
                    : "Never"}
                </div>
              </div>
            </StaffRow>
          ))
        )}
      </Model>
  );
};


const Header = tw.div`flex justify-between items-center mb-4`;
const StaffRow = tw.div`border rounded-md p-4 mb-3 flex items-center justify-between hover:bg-slate-50 transition`;

export default ViewDetailStaff;